module.exports = __webpack_public_path__ + "officialStatic/img/partenerBg.d0e892d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/partenerBg.jpg
// module id = 5/Gh
// module chunks = 0